export function LogoMark({ className = "h-9 w-9" }) {
  return <img src="/logo.png" alt="" className={`${className} object-contain`} aria-hidden="true" />;
}

export default function Logo({ light = false }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark className="h-9 w-9" />
      <span className={`font-display text-xl leading-none tracking-tight ${light ? "text-white" : "text-ink"}`}>
        in your corner
        <span className="mt-0.5 block font-sans text-[10px] font-bold uppercase tracking-[0.22em] text-ink-faint">
          healthcare
        </span>
      </span>
    </span>
  );
}
